
/* injects from baggage-loader */
require('./style.scss');

import React, { useState } from "react";
import { connect } from "react-redux";
import KeyboardInput from "../InputKeyboard";
import { t } from "../../../helpers/translator";
import { ClosePopup, OpenPopup } from "../../../actions/ui";
import Zergling from "../../../helpers/zergling";
const TransferToAccount = (props) => {
    const [clientId, setClientId] = useState('');
    const [clientNotFound, setClientNotFound] = useState(false)
    const handleChange = (value) => {
        const valMoney = /^[0-9]*$/;
        
        if(valMoney.test(value)) {
            setClientId(value)
        }
    }
    const findPlayer = () => {
        const token = JSON.parse(sessionStorage.getItem("authData")).token
        Zergling.get({"token": token, "filter": {"id": +clientId}},
            "terminal_find_player")
            .then(response => {
                const client = response.data[0]
                if (client) {
                    props.dispatch(OpenPopup("transferToAccountDetails", { client }))
                } else {
                    setClientNotFound(true)
                }
        });
    }
    return (
        <div className='transfer-to-account-container'>
            <p className='transfer-to-account-title'>{t("Transfer to Account")}</p>
            <p className='transfer-to-account-sub-title'>{t("Enter the client ID to which you want to transfer the money")}</p>
            <div className='client-input-container'>
                <p>{t("Client ID")}</p>
                <KeyboardInput
                    numeric
                    type='text'
                    value={clientId}
                    class={`input-field-v single-form-item ${clientNotFound ? 'error' : ''}`}
                    onChange={handleChange}
                />
                {
                    clientNotFound &&
                        <p className="error-message">{t("No account was found with this Id")}</p>
                }
            </div>
            <div className='buttons-container'>
            <button
                className='button-view-normal-m cancel'
                onClick={() => props.dispatch(ClosePopup(true))}>
                    Cancel
            </button>
            <button
                disabled={!clientId}
                className='button-view-normal-m'
                onClick={findPlayer}
            >
                Find
            </button>
            </div>
        </div>
    )
}
export default connect()(TransferToAccount)